import { ContentId, DocumentId } from './contentMetadata';

export enum ContentPublishState {
  Archived = 'Archived',
  Off = 'Off',
  NoEdits = 'NoEdits',
  CanPublish = 'CanPublish',
}

export enum DocumentPublishState {
  NoEdits = 'NoEdits',
  HasErrors = 'HasErrors',
  CanPublish = 'CanPublish',
}

export interface DocumentPublishStatus {
  id: DocumentId;
  state: DocumentPublishState;
  latestCommitAt: string;
}

export interface ContentPublishStatus {
  id: ContentId;
  state: ContentPublishState;
  documentStatuses: DocumentPublishStatus[];
}
